import { useNavigate } from "react-router-dom";
import HeaderComponent from "../../components/header";
import ContainerComponent from "../../components/conatiner";
import CardComponent from "../../components/card";
import InputComponent from "../../components/input";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { CreateUserService, RolesService } from "../../services/users";
import { ToastErro, ToastSucesso } from "../../components/toast";
import LoadingComponent from "../../components/loading";

const CreateUserPage = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(true);

    const [roles, setRoles] = useState<any>([]);

    // variaveis para cadastrar
    const [name, setName] = useState<string>('');
    const [username, setUsername] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [confPassword, setConfPassword] = useState<string>('');    
    // variaveis para cadastrar

    // pequisar roles
    const getRoles = async () => {

        setLoading(true);

        await RolesService().then(resp => {
            setRoles(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // pequisar roles

    // funcao para salvar usuário
    const createUser = async (e: FormEvent) => {

        e.preventDefault();

        let userRoles: any = [];

        (window as any).$(".userRole:checked").each((i: number, e: any) => {
            userRoles.push(e.value);
        });

        if(userRoles.length < 1)
        {
            ToastErro('Selecione no mínimo 1 permissão!');
            return;
        }

        setLoading(true);

        await CreateUserService(name, username, email, password, JSON.stringify(userRoles)).then(resp => {
            ToastSucesso(resp.data.message);
            navigate('/users');
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // funcao para salvar usuário

    useEffect(() => {
        getRoles();
    }, []);

    return (
        <>
            <HeaderComponent
                title="Cadastrar Usuário"
                button="Voltar"
                iconButton="arrow_back"
                onClick={() => navigate('/users')}
            />
            <ContainerComponent>
                {
                    loading

                        ?

                        <LoadingComponent />

                        :

                        <form onSubmit={createUser}>
                            <div className="row">
                                <CardComponent
                                    col={8}
                                >
                                    <>
                                        <div className="card-title mb-4">
                                            Informações do Usuário
                                        </div>
                                        <div className="row">
                                            <InputComponent
                                                label="Nome"
                                                col={12}
                                                defaultValue={name}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="row">
                                            <InputComponent
                                                label="Usuário"
                                                col={6}
                                                defaultValue={username}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)}
                                                required
                                            />
                                            <InputComponent
                                                label="E-mail"
                                                col={6}
                                                defaultValue={email}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                                required
                                            />
                                        </div>                                        
                                        <div className="row">
                                            <InputComponent
                                                label="Senha"
                                                col={6}
                                                defaultValue={password}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                                                type={"password"}
                                                required
                                            />
                                            <InputComponent
                                                label="Confirme a Senha"
                                                col={6}
                                                defaultValue={confPassword}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => setConfPassword(e.target.value)}
                                                type={"password"}
                                                required
                                            />
                                        </div>
                                    </>
                                </CardComponent>
                                <CardComponent
                                    col={4}
                                >
                                    <>
                                        <div className="card-title mb-4">
                                            Permissões do Usuário
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Selecione</th>
                                                            <th scope="col">ID</th>
                                                            <th scope="col">Descrição</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            roles.map((r: any) => {
                                                                return (
                                                                    <tr key={r.id}>
                                                                        <td><input type="checkbox" className="userRole" defaultValue={r.id} /></td>
                                                                        <td>{r.id}</td>
                                                                        <td>{r.description}</td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </>
                                </CardComponent>
                            </div>

                            <div className="d-flex justify-content-end mt-4">
                                <button className="btn btn-primary" type="submit">Cadastrar</button>
                            </div>
                        </form>
                }
            </ContainerComponent>
        </>
    )

}

export default CreateUserPage;